"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleMonthKeyPress = void 0;

var date_fns_1 = require("date-fns");

var setPreviousMonth = function setPreviousMonth(_a) {
  var selectedDate = _a.selectedDate,
      setSelectedDate = _a.setSelectedDate;
  var previousMonth = (0, date_fns_1.subMonths)(selectedDate, 1);
  setSelectedDate(previousMonth);
};

var setNextMonth = function setNextMonth(_a) {
  var selectedDate = _a.selectedDate,
      setSelectedDate = _a.setSelectedDate;
  var nextMonth = (0, date_fns_1.addMonths)(selectedDate, 1);
  setSelectedDate(nextMonth);
};

var setPreviousQuarter = function setPreviousQuarter(_a) {
  var selectedDate = _a.selectedDate,
      setSelectedDate = _a.setSelectedDate;
  var previousQuarter = (0, date_fns_1.subMonths)(selectedDate, 3);
  setSelectedDate(previousQuarter);
};

var setNextQuarter = function setNextQuarter(_a) {
  var selectedDate = _a.selectedDate,
      setSelectedDate = _a.setSelectedDate;
  var nextQuarter = (0, date_fns_1.addMonths)(selectedDate, 3);
  setSelectedDate(nextQuarter);
};

var setDatePreviousYear = function setDatePreviousYear(_a) {
  var selectedDate = _a.selectedDate,
      setSelectedDate = _a.setSelectedDate;
  setSelectedDate((0, date_fns_1.subYears)(selectedDate, 1));
};

var setDateNextYear = function setDateNextYear(_a) {
  var selectedDate = _a.selectedDate,
      setSelectedDate = _a.setSelectedDate;
  setSelectedDate((0, date_fns_1.addYears)(selectedDate, 1));
};

var setFirstMonth = function setFirstMonth(_a) {
  var selectedDate = _a.selectedDate,
      setSelectedDate = _a.setSelectedDate;
  var firstMonth = (0, date_fns_1.set)(selectedDate, {
    month: 0
  });
  setSelectedDate(firstMonth);
};

var setLastMonth = function setLastMonth(_a) {
  var selectedDate = _a.selectedDate,
      setSelectedDate = _a.setSelectedDate;
  var lastMonth = (0, date_fns_1.set)(selectedDate, {
    month: 11
  });
  setSelectedDate(lastMonth);
};

var handleMonthKeyPress = function handleMonthKeyPress(_a) {
  var selectedDate = _a.selectedDate,
      setSelectedDate = _a.setSelectedDate,
      event = _a.event,
      onSelectDate = _a.onSelectDate;
  var key = event.key;
  var state = {
    selectedDate: selectedDate,
    setSelectedDate: setSelectedDate
  };

  switch (key) {
    case 'Enter':
      onSelectDate();
      return;

    case ' ':
      onSelectDate();
      return;

    case 'PageUp':
      setDatePreviousYear(state);
      return;

    case 'PageDown':
      setDateNextYear(state);
      return;

    case 'End':
      setLastMonth(state);
      return;

    case 'Home':
      setFirstMonth(state);
      return;

    case 'ArrowLeft':
      setPreviousMonth(state);
      return;

    case 'ArrowUp':
      setPreviousQuarter(state);
      return;

    case 'ArrowRight':
      setNextMonth(state);
      return;

    case 'ArrowDown':
      setNextQuarter(state);
      return;

    default:
      return;
  }
};

exports.handleMonthKeyPress = handleMonthKeyPress;